/**
 * Canonical "deposit required" visual treatment.
 *
 * Every surface that flags a deposit requirement — the deposit chip, the
 * create-appointment warning callout, and the waive/reinstate actions —
 * shares this orange look. The class strings live here so the
 * treatment is restyled in one place rather than at each surface it appears.
 */

/**
 * Orange colour pair flagging a deposit requirement. Also the
 * `DepositStatus.Required` entry in `DEPOSIT_STATUS_COLOURS`.
 */
export const DEPOSIT_REQUIRED_COLOUR_CLASSES = 'bg-orange-100 text-orange-800';

/**
 * Warning callout surfaced when a deposit requirement needs attention before
 * the appointment can be saved.
 */
export const DEPOSIT_REQUIRED_WARNING_CLASSES =
  'rounded-md bg-orange-50 p-3 text-sm text-orange-800';

/**
 * Icon-button treatment for the deposit waiver actions (waive / reinstate).
 */
export const DEPOSIT_REQUIRED_ACTION_CLASSES =
  'text-orange-600 hover:text-orange-800';
